import Breadcrumb from "../components/Breadcrumb";
import CertificateOne from "../components/CertificateOne";
import HeaderOne from "../components/HeaderOne";
import TutorDetails from "../components/TutorDetails";
import Animation from "../helper/Animation";
import Preloader from "../helper/Preloader";

const TutorDetailsPage = () => {
  return (
    <>
      {/* Preloader */}
      <Preloader />

      {/* Animation */}
      <Animation />

      {/* HeaderTwo */}
      <HeaderOne />

      {/* Breadcrumb */}
      <Breadcrumb title={"Tutors Details"} />

      {/* TutorDetails */}
      <TutorDetails />

      {/* CertificateOne */}
      <CertificateOne />

      {/* FooterOne */}
      
    </>
  );
};

export default TutorDetailsPage;
